/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiemsRulesPLFixedRatesRes,
    DiemsRulesPLFixedRatesResFromJSON,
    DiemsRulesPLFixedRatesResFromJSONTyped,
    DiemsRulesPLFixedRatesResToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyDiemsRules
 */
export interface ReadOnlyDiemsRules {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDiemsRules
     */
    id?: string;
    /**
     * 
     * @type {DiemsRulesPLFixedRatesRes}
     * @memberof ReadOnlyDiemsRules
     */
    plFixedRates?: DiemsRulesPLFixedRatesRes | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRules
     */
    readonly deleted?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyDiemsRules
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyDiemsRules
     */
    end?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyDiemsRules
     */
    replacedMeals?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRules
     */
    pocketMoney?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyDiemsRules
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyDiemsRules
     */
    concatForeignDiems?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRules
     */
    client: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDiemsRules
     */
    user?: number | null;
}

export function ReadOnlyDiemsRulesFromJSON(json: any): ReadOnlyDiemsRules {
    return ReadOnlyDiemsRulesFromJSONTyped(json, false);
}

export function ReadOnlyDiemsRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyDiemsRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'plFixedRates': !exists(json, 'pl_fixed_rates') ? undefined : DiemsRulesPLFixedRatesResFromJSON(json['pl_fixed_rates']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (json['end'] === null ? null : new Date(json['end'])),
        'replacedMeals': !exists(json, 'replaced_meals') ? undefined : json['replaced_meals'],
        'pocketMoney': !exists(json, 'pocket_money') ? undefined : json['pocket_money'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'concatForeignDiems': !exists(json, 'concat_foreign_diems') ? undefined : json['concat_foreign_diems'],
        'client': json['client'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function ReadOnlyDiemsRulesToJSON(value?: ReadOnlyDiemsRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pl_fixed_rates': DiemsRulesPLFixedRatesResToJSON(value.plFixedRates),
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end === null ? null : value.end.toISOString()),
        'replaced_meals': value.replacedMeals,
        'pocket_money': value.pocketMoney,
        'concat_foreign_diems': value.concatForeignDiems,
        'client': value.client,
        'user': value.user,
    };
}


